/**
 * Utility to extract a YouTube embed URL from raw API links.
 * Returns standard embed URL for iframe or null if invalid.
 */
export const getYouTubeEmbedUrl = (url?: string | null): string | null => {
  if (!url || typeof url !== "string") return null;
  const match = url.trim().match(
    /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
  );
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};
